import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { Box } from '@chakra-ui/react';
export function BackgroundScene() {
  const containerRef = useRef<HTMLDivElement>(null);
  const sceneRef = useRef<THREE.Scene | null>(null);
  const cameraRef = useRef<THREE.PerspectiveCamera | null>(null);
  const rendererRef = useRef<THREE.WebGLRenderer | null>(null);
  const particlesRef = useRef<THREE.Points | null>(null);
  const frameIdRef = useRef<number | null>(null);
  useEffect(() => {
    // Initialize scene
    const scene = new THREE.Scene();
    sceneRef.current = scene;
    // Camera setup
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 50;
    cameraRef.current = camera;
    // Renderer setup
    const renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true
    });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0x000000, 0);
    rendererRef.current = renderer;
    // Add renderer to DOM
    if (containerRef.current) {
      containerRef.current.appendChild(renderer.domElement);
      resizeRenderer();
    }
    // Create particles
    const particlesGeometry = new THREE.BufferGeometry();
    const particlesCount = 1500;
    const posArray = new Float32Array(particlesCount * 3);
    for (let i = 0; i < particlesCount * 3; i++) {
      posArray[i] = (Math.random() - 0.5) * 100;
    }
    particlesGeometry.setAttribute('position', new THREE.BufferAttribute(posArray, 3));
    // Material with custom shader
    const particlesMaterial = new THREE.PointsMaterial({
      size: 0.2,
      transparent: true,
      color: 0x0099ff,
      blending: THREE.AdditiveBlending
    });
    // Create points
    const particles = new THREE.Points(particlesGeometry, particlesMaterial);
    scene.add(particles);
    particlesRef.current = particles;
    // Handle window resize
    window.addEventListener('resize', resizeRenderer);
    // Animation loop
    const animate = () => {
      if (particles) {
        particles.rotation.x += 0.0005;
        particles.rotation.y += 0.0005;
      }
      if (renderer && scene && camera) {
        renderer.render(scene, camera);
      }
      frameIdRef.current = requestAnimationFrame(animate);
    };
    animate();
    // Cleanup
    return () => {
      if (frameIdRef.current !== null) {
        cancelAnimationFrame(frameIdRef.current);
      }
      if (containerRef.current && renderer) {
        containerRef.current.removeChild(renderer.domElement);
      }
      window.removeEventListener('resize', resizeRenderer);
    };
  }, []);
  const resizeRenderer = () => {
    if (containerRef.current && rendererRef.current && cameraRef.current) {
      const width = containerRef.current.clientWidth;
      const height = containerRef.current.clientHeight;
      rendererRef.current.setSize(width, height);
      cameraRef.current.aspect = width / height;
      cameraRef.current.updateProjectionMatrix();
    }
  };
  return <Box ref={containerRef} position="absolute" top="0" left="0" width="100%" height="100vh" zIndex="0" opacity={0.6} pointerEvents="none" data-id="element-16" />;
}